import React from "react";
import {
  Box,
  Chip,
  Drawer,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";

import StockOutPanel from "./StockOutPanel";
import { platformLabel } from "./constants";

/**
 * The stock out for one import, in its own drawer.
 *
 * It is kept apart from the report drawer on purpose: the report is a long
 * read, while this is a decision - what leaves stock, or what already did.
 */
const StockOutDrawer = ({
  open,
  row,
  stockOut,
  canStockOut,
  onClose,
  onStockOut,
  onUndo,
  onRevert,
}) => (
  <Drawer
    anchor="right"
    open={open}
    onClose={onClose}
    PaperProps={{ sx: { width: { xs: "100%", md: "82%" } } }}
  >
    <Box sx={{ p: 3 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        sx={{ mb: 1 }}
      >
        <Box>
          <Typography variant="h6" sx={{ mb: 0.5 }}>
            Stock Out - {row?.originalFileName ?? "Import"}
          </Typography>
          {row && (
            <Stack direction="row" flexWrap="wrap" sx={{ gap: 1 }}>
              <Chip size="small" label={platformLabel(row.platform)} />
              <Chip
                size="small"
                label={moment(row.date).format("DD/MM/YYYY HH:mm")}
              />
              <Chip size="small" label={`${row.totalRows} rows parsed`} />
              {row.isEdited && (
                <Chip
                  size="small"
                  color="warning"
                  variant="outlined"
                  label={`${row.adjustedRows} after edits`}
                />
              )}
              {row.importedBy?.name && (
                <Chip
                  size="small"
                  variant="outlined"
                  label={`Imported by ${row.importedBy.name}`}
                />
              )}
            </Stack>
          )}
        </Box>
        <IconButton onClick={onClose} aria-label="Close">
          <CloseIcon />
        </IconButton>
      </Stack>

      <StockOutPanel
        stockOut={stockOut}
        canStockOut={canStockOut}
        onStockOut={onStockOut}
        onUndo={onUndo}
        onRevert={onRevert}
      />
    </Box>
  </Drawer>
);

export default StockOutDrawer;
